import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {PatronActions} from '@store/patron/patron.actions';
import {Store} from '@ngrx/store';

@Component({
  selector: 'rn-logout',
  template: '',
  standalone: false
})
export class LogoutComponent implements OnInit {
  message: string;

  constructor(
    public router: Router,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    // log the person out
    this.store.dispatch(PatronActions.logoutPatron());
  }
}
